export enum systemTransactionsList{
  assetCycleCount = 1,
  assetCheckIn = 2,
  assetcheckOut = 3,
  assetDepreciate = 4,
  assetDispose = 5,
  assetReceive = 6,
  assetReservation = 7,
  assetMove = 8,
  assetPerformMaintenance = 9,
  assetScheduleMaintenance = 10,
  assetcustodyRequests = 11,
  assetDisposalRequests = 12,
  assetMaintenanceRequests = 13,
  assetReturnRequests = 14,
  assetTransferRequests = 15,
  assetPhysicalInventory = 16,
  assetDepreciation = 16
}
